const FacebookService = {
  /**
   * Initializes facebook login, loads sdk, sets the onclick for all facebook buttons on the page.
   * @param  {Object} options Alternative options for configuring the facebook button, like appID for testing, bloodhound tags, or alternative text.
   * @return {String or [String]} Returns either a new facebook button, or a list of ones currently on the page.
   */
  init: function(options) {
    const app_id = options.app_id || FacebookService.getAppID(options);
    const locale = options.locale || FacebookService.getLocale();
    const version = 'v3.0';
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: app_id,
        status: true, // Determines the user's status is freshly retrieved. According to the comments in groupon social, not turning this on prevents the user's status from being properly returned when checkLoginStatus is called.
        cookie: false, // Enables of disables a cookie being generated for the users authentication session. This is turned off because saving our signed request with an unsecure is not a good idea. In fairness, this is taken from a comment on groupon social, so I am unsure as to how valid this concern is now.
        xfbml: true, // Determines wether eXtended FaceBook Markup Language (XFBML) tags are enabled. This makes it easier for facebook sdk to identify what resources are used on the page and load in the correct plugins.
        version: version,
      });
    }.bind(this);
    (function(d, s, id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      const js = d.createElement(s);
      js.id = id;
      js.async = true;
      js.src = `https://connect.facebook.net/${locale}/sdk.js#xfbml=1&version=${version}&appId=${app_id}&autoLogAppEvents=1`;
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    const containers = document.querySelectorAll('.facebook-login');
    if (containers.length === 0) {
      return FacebookService.renderFacebookButtonHTML(options);
    }
    for (let i = 0; i < containers.length; ++i) {
      containers[i].onclick = FacebookService.login;
    }
    return containers;
  },
  renderReAuthModal: function() {
    const modal_header = window.I18n.t(
      'js.modules.facebook.rerequest_modal_header'
    );
    const modal_body = window.I18n.t(
      'js.modules.facebook.rerequest_modal_body'
    );
    const modal_button_text = window.I18n.t(
      'js.modules.facebook.rerequest_modal_button'
    );
    const no_thanks = window.I18n.t('js.modules.facebook.rerequest_no_thanks');
    const modal_template = `<div class="modal" aria-hidden="true" aria-labelledby="triggerId" aria-modal="false" id="facebook_reauth_modal">
       <div class="modal-body">
         <h2 class="modal-title section-title text-center">
           ${modal_header}
         </h2>
         <div class="row text-center">
           <p>${modal_body}</p>
         </div>
         <div class="row text-center">
           <button class="btn" id="fb-reauth-submit">${modal_button_text}</button>
           <div class="row">
            <a href="#" class="close-modal">${no_thanks}</a>
           </div>
         </div>
       </div>
      </div>`;
    if (
      (typeof window.TouchData !== 'undefined' &&
        window.TouchData !== null &&
        window.TouchData.touchRequest) ||
      document.querySelector('#app #main-content')
    ) {
      //this might end up being styled horribly if we full delete groupon social
      document.querySelector('div.t-main').style.opacity = '0.5';
      const htmlModal = document.createElement('div');
      htmlModal.innerHTML = modal_template;
      document.body.append(htmlModal);
      htmlModal.querySelector('.modal').classList.add('fb-reauth'); //for styling

      const closeModalEvent = function(event) {
        if (
          typeof window !== 'undefined' &&
          window !== null &&
          document.querySelector('.modal') &&
          !document.querySelector('.modal').contains(event.target)
        ) {
          document
            .querySelector('.modal')
            .parentNode.removeChild(document.querySelector('.modal'));
          document.querySelector('div.t-main').style.opacity = '1';
          document.removeEventListener('click', closeModalEvent);
        }
      };
      document.addEventListener('click', closeModalEvent);

      const closeModal = function() {
        document
          .querySelector('.modal')
          .parentNode.removeChild(document.querySelector('.modal'));
        document.querySelector('div.t-main').style.opacity = '1';
        document.removeEventListener('click', closeModalEvent);
      };
      htmlModal.querySelector('.close-modal').onclick = closeModal;
    } else {
      window.GIG.Modal.create(modal_template);
    }
    window.document
      .querySelector(`#fb-reauth-submit`)
      .addEventListener('click', () => {
        FacebookService.login(true);
      });
  },
  /**
   * Prompts the user to login. Wrapper for FB.login.
   * @return {NULL} Does not return anything.
   */
  login: function(rerequest = false) {
    window.FB.login(
      response => {
        if (response.authResponse) {
          if (!response.authResponse.grantedScopes.includes('email')) {
            FacebookService.renderReAuthModal();
          } else {
            FacebookService.successHandler(response);
          }
        } else {
          window.Groupon.Utils.trackEvent(
            'facebook-signin-authentication-failure',
            { error: response }
          );
        }
      },
      {
        scope: 'public_profile,email',
        return_scopes: true,
        auth_type: rerequest ? 'rerequest' : '',
      }
    );
  },
  /**
   * Gets the Facebook app id given the current environment.
   * @return {String} Returns the facebook app id
   */
  getAppID: function(options) {
    if (
      typeof window !== 'undefined' && window !== null
        ? typeof window.facebookData !== 'undefined' &&
          window.facebookData !== null
          ? window.facebookData.facebookAppId
          : void 0
        : void 0
    ) {
      return window.facebookData.facebookAppId;
    } else {
      if (
        typeof options !== 'undefined' &&
        options !== null &&
        options.env === 'livingSocialStaging'
      ) {
        return '10154404427080838';
      } else {
        return '7829106395'; //This is the app id for US, and is considered the fallback if layoutservice's is not available.
      }
    }
  },
  /**
   * Gets the locale, which is the language + region.
   * @return {String} Retuns a string of the locale.
   */
  getLocale: function() {
    if (
      typeof window !== 'undefined' && window !== null
        ? typeof window.facebookData !== 'undefined' &&
          window.facebookData !== null
          ? window.facebookData.locale
          : void 0
        : void 0
    ) {
      return window.facebookData.locale;
    } else {
      return 'en_US';
    }
  },
  /**
   * Helper function for rendering the facebook login button.
   * @param  {JSON Object} options Alternative options for configuring the facebook button (already translated), like Facebook appID, bloodhound tags, or something else.
   * @return {String}         Returns the facebook button html.
   */
  renderFacebookButtonHTML: function(options = {}, component = null) {
    const bloodhoundtag = options.bloodhound || 'FacebookButton';
    const message = options.message || 'Facebook';
    const facebookTemplate = `<div class="facebook-login" data-bhw=${bloodhoundtag}>
       <div class="facebook-login-button new-icon" tabindex="0">
         <div class="custom-icon-facebook"></div>
         <div class="facebook-button-text">
           <span class="text-facebook">${message}</span>
         </div>
       </div>
      </div>`;
    if (
      component !== null &&
      typeof document !== 'undefined' &&
      document !== null
    ) {
      const htmlFacebookButton = document.querySelector(component);
      htmlFacebookButton.innerHTML = facebookTemplate;
      htmlFacebookButton.querySelector('.facebook-login').onclick =
        FacebookService.login;
    }
    return facebookTemplate;
  },
  /**
   * Check if the remember me element is checked off.
   * @return {Boolean} Returns if the current tab's remember me is checked or not.
   */
  getRememberMeElem: function() {
    const isLogInTabview =
      document.querySelector('.tab-content.login-content.active') !== null;
    const isSignUpTabView =
      document.querySelector('.tab-content.signup-content.active') !== null;
    if (isLogInTabview) {
      const isLogInRememberMeChecked =
        document.querySelector('#remember-me-checkbox:checked') !== null;
      return isLogInRememberMeChecked;
    } else if (isSignUpTabView) {
      const isSignUpRememberMeChecked =
        document.querySelector('#signup-rememberMe-input:checked') !== null;
      return isSignUpRememberMeChecked;
    } else {
      const isNonTabviewRememberMeChecked =
        document.querySelector('#groupon-social-remember-me:checked') !== null;
      return isNonTabviewRememberMeChecked;
    }
  },
  /**
   * Return if the newsletter element is present
   * @return {Boolean} Returns if the newsletter object is returned.
   */
  getNewsletterElem: function() {
    const isSignUpTabView =
      document.querySelector('.tab-content.signup-content.active') !== null;

    const isSignUpViewForIframe =
      document.querySelector('.iframe-signup .title.signup-only') !== null;

    const isSignUpNewsletterChecked =
      document.querySelector('#signup-newsletter-input:checked') !== null ||
      document.querySelector('#newsletter-checkbox:checked') !== null;

    const isUnifiedLogin = document.querySelector('#app #main-content');

    return !!(
      ((isSignUpTabView || isSignUpViewForIframe) &&
        isSignUpNewsletterChecked) ||
      (isSignUpNewsletterChecked && isUnifiedLogin)
    );
  },

  /**
   * Gets the tab name for the current button. Basically decides if login, signup, or iFrame.
   * @return {String} Returns either login or signup.
   */
  getTabName: function() {
    const isLogInTabview =
      document.querySelector('.tab-content.login-content.active') !== null;
    const isSignUpTabView =
      document.querySelector('.tab-content.signup-content.active') !== null;
    const isIframe = document.querySelector('.login-iframe') !== null;
    if (isLogInTabview) {
      return 'login';
    } else if (isSignUpTabView) {
      return 'signup';
    } else if (isIframe) {
      return 'iframe';
    } else {
      return '';
    }
  },
  /**
   * Success Handler for init. Used to pull out the various attributes of the facebook login, and push them to the backend.
   * @param  {Object} res The result of the previously called function, usually FB.Login
   * @return {Null}     Does not return anything, simply calls the facebook authentication backend.
   */
  successHandler: function(res) {
    if (!res) {
      return;
    }
    const facebook_access_token = res.authResponse.accessToken;
    const signed_request = res.authResponse.signedRequest;
    const xhr = new XMLHttpRequest();
    const host = window.location.origin;
    const qs = window.location.search;
    const postUrl = `${host}/facebook${qs}`;
    const csrfElement = document.querySelector('input[name=_csrf]');
    const _csrf = csrfElement
      ? document.querySelector('input[name=_csrf]').value
      : window.Groupon.Utils.getConfigFromDom().appState.csrf;
    const rememberMe = FacebookService.getRememberMeElem();
    const newsletter = FacebookService.getNewsletterElem();

    const formData = `_csrf=${_csrf}&access_token=${facebook_access_token}&signed_request=${signed_request}&remember_me=${rememberMe}&newsletter=${newsletter}`;
    xhr.open('POST', postUrl);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onload = function(e) {
      if (xhr.readyState === 4) {
        //This is an edge case where a user deletes our permissions while they are still on the login page.
        //If they don't refresh, facebook (i.e. FB.checkLoginStatus) still thinks the credential is valid, but the request won't go through.
        //Probably also good just in case a token expires.
        if (
          xhr.status === 400 &&
          xhr.response.includes('User credentials are invalid')
        ) {
          FacebookService.login();
        } else if (xhr.status === 200) {
          const response = JSON.parse(xhr.responseText);
          if (FacebookService.getTabName() === 'iframe') {
            if (typeof window !== 'undefined' && window !== null) {
              window.top.location.reload();
            }
          } else {
            if (typeof window !== 'undefined' && window !== null) {
              window.location.href = response.location;
            }
          }
        } else {
          if (typeof window !== 'undefined' && window !== null) {
            window.Groupon.Utils.trackEvent('facebook-signin-xhr-failure', {
              error: e,
            });
          }
        }
      }
    };
    xhr.error = function(error) {
      return typeof window !== 'undefined' && window !== null
        ? window.Groupon.Utils.trackEvent('facebook-signin-xhr-failure', {
            error: error,
          })
        : void 0;
    };
    xhr.send(formData);
  },

  failureHandler: function(error) {
    return typeof window !== 'undefined' && window !== null
      ? window.Groupon.Utils.trackEvent('facebook-signin-xhr-failure', {
          error: error,
        })
      : void 0;
  },
};
module.exports = FacebookService;
